module.exports = {
      id: "icon-more-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-more",
      toString: function () {
        return this.url;
      }
    }